import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import axios from 'axios';
import Box from '@mui/system/Box';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import _ from '@lodash';
import * as yup from 'yup';
import { selectUser } from 'app/store/userSlice';
import { showMessage } from 'app/store/fuse/messageSlice';

/**
 * Form Validation Schema
 */
const schema = yup.object().shape({
  descritor: yup
    .string()
    .required('O campo Descritor é obrigatório'),
  conteudo: yup
    .string()
    .required('O campo Conteúdo é obrigatório')
})

const defaultValues = {
  descritor: '',
  conteudo: ''
}

function Content(props) {
  const { handleSubmit, control, methods, formState } = useForm({
    mode: 'onChange',
    defaultValues,
    resolver: yupResolver(schema),
  });

  const routeParams = useParams();
  const dispatch = useDispatch();
  const { errors, dirtyFields, isValid } = formState;

  const [open, setOpen] = useState(false);
  const [messagemModal, setMessagemModal] = useState('');
  const [fieldFormulacaoPadrao, setFieldFormulacaoPadrao] = useState(true);
  const [verboDisabled, setVerboDisabled] = useState(true);
  const [nivelCognitivoDisabled, setNivelCognitivoDisabled] = useState(true);
  const [conteudoDisabled, setConteudoDisabled] = useState(true);

  const [formulacaoPadrao, setFormulacaoPadrao] = useState([]);
  const [nivelCognitivo, setNivelCognitivo] = useState([]);
  const [descritor, setDescritor] = useState([]);
  const [verbos, setVerbos] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const user = useSelector(selectUser);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleKeyPress = (e, field) => {
    const inputValue = e.target.value;
    const valorBuscado = 'Recitar';
    setMessagemModal('Erro de sintaxe, esse verbo é reservado para um nível cognitivo. Substitua o verbo');
    if (inputValue.includes(valorBuscado)) {
      const inputValueSemRecitar = inputValue.replace(valorBuscado, '');
      field.onChange(inputValueSemRecitar);
      setOpen(true);
    }
  };

  const onChangeFormulacaoPadrao = (inputValue) => {
    const valorBuscado = 'Recitar';
    setMessagemModal('Este é um verbo reservado a um nível cognitivo, que deverá ser escolhido no campo (Verbo)');
    if (inputValue.includes(valorBuscado)) {
      const inputValueSemRecitar = inputValue.replace(valorBuscado, '');
      setOpen(true);
      return inputValueSemRecitar;
    } else {
      return inputValue;
    }
  };

  const findNivelCognitivo = (value) => {
    if (descritor) {
      setVerbos([]);
    }
    axios.post(process.env.REACT_APP_API_URL + 'niveis/', { descritor: value }).then(function (response) {
      setNivelCognitivo(response.data);
    }).catch(error => {
      console.error(error);
    })
  };

  const findVerbos = (value) => {
    axios.post(process.env.REACT_APP_API_URL + 'verbos/pesquisa/', { id_nivel: value }).then(function (response) {
      setVerbos(response.data);
    }).catch(error => {
      console.error(error);
    })
  };

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_URL + 'tipo-nivel/', {}).then(function (response) {
      setDescritor(response.data);
    }).catch(error => {
      console.error(error);
    })

    axios.get(process.env.REACT_APP_API_URL + 'formulacao-padrao/', {}).then(function (response) {
      setFormulacaoPadrao(response.data);
    }).catch(error => {
      console.error(error);
    })    
  }, []);

  const valueToIdMap = new Map();
  descritor.forEach((item) => {
    valueToIdMap.set(item.no_tipo_nivel, item.id_tipo_nivel);
  });

  const valueToIdMapVerbos = new Map();
  nivelCognitivo.forEach((item) => {
    valueToIdMapVerbos.set(item.no_nivel, item.id_nivel);
  });

  const valueToIdMapFormulacaoPadrao = new Map();
  formulacaoPadrao.forEach((item) => {
    valueToIdMapFormulacaoPadrao.set(item.no_formulacao_padrao, item.id_formulacao_padrao);
  });

  const valueToIdMapVerbo = new Map();
  verbos.forEach((item) => {
    valueToIdMapVerbo.set(item.no_verbo, item.id_verbo);
  });

  const save = (data) => {
    axios.post(process.env.REACT_APP_API_URL + 'planejamento/save', data).then(function (response) {
      console.log('save: ', response);
      dispatch(showMessage({
        message: response.data.message, 
        autoHideDuration: 2000,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center',
        },
      }));
    }).catch(error => {
      console.error(error);
    })
  };

  /**
   * Form Submit
   */
  function onSubmit(data) {
    let dataForm = {
      ds_tipo_ensino: data.tipoEnsino,
      ds_turma: data.turma,
      ds_disciplina: data.disciplina,
      nu_ano: data.ano,
      id_descritor: valueToIdMap.get(data.descritor),
      id_nivel_cognitivo: valueToIdMapVerbos.get(data.nivelCognitivo),
      id_formulacao_padrao: valueToIdMapFormulacaoPadrao.get(data.formulacaoPadrao),
      id_verbo: valueToIdMapVerbo.get(data.verbo),
      ds_conteudo: data.conteudo,
      id_user: user.uuid ? user.uuid : null
    }
    save(dataForm);
  }

  return (
    <>
      <div>
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Alerta</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Stack sx={{ width: '100%' }} spacing={2}>
                <Alert severity="error">
                  {messagemModal}
                </Alert>
              </Stack>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Fechar
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      <div>
        <form
          name='planejamentoForm'
          noValidate
          className='flex flex-col justify-center w-full mt-32'
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="flex -mx-4">
            <div className="w-1/4 px-4">

              <Controller
                name="descritor"
                control={control}
                defaultValue=""
                render={({ field: { onChange, value } }) => (
                  <div>
                    <Autocomplete
                      className="mt-8 mb-16"
                      freeSolo
                      options={descritor.map((option) => option.no_tipo_nivel)}
                      value={value}
                      id='descritor'
                      onChange={(event, newValue) => {
                        onChange(newValue);
                        const selectedId = valueToIdMap.get(newValue);
                        findNivelCognitivo(selectedId);
                        setFieldFormulacaoPadrao(false);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Selecione"
                          label="Descritor"
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      )}
                    />
                  </div>
                )}
              />
            </div>

            <div className="w-1/3 px-4">
              <Controller
                name="tipoEnsino"
                control={control}
                defaultValue={inputValue}
                render={({ field }) => (
                  <TextField
                    {...field}
                    className="mt-8 mb-16"
                    label="Tipo de Ensino"
                    autoFocus
                    id="tipoEnsino"
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </div>

            <div className="w-1/3 px-4">
              <Controller
                name="turma"
                control={control}
                defaultValue={inputValue}
                render={({ field }) => (
                  <TextField
                    {...field}
                    className="mt-8 mb-16"
                    label="Turma"
                    autoFocus
                    id="turma"
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </div>

            <div className="w-1/3 px-4">
              <Controller
                name="disciplina"
                control={control}
                defaultValue={inputValue}
                render={({ field }) => (
                  <TextField
                    {...field}
                    className="mt-8 mb-16"
                    label="Disciplina"
                    autoFocus
                    id="disciplina"
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </div>

            <div className="w-1/3 px-4">
              <Controller
                name="ano"
                control={control}
                defaultValue={inputValue}
                render={({ field }) => (
                  <TextField
                    {...field}
                    className="mt-8 mb-16"
                    label="Ano"
                    autoFocus
                    id="ano"
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </div>
          </div>

          <Controller
            name="formulacaoPadrao"
            control={control}
            defaultValue=""
            render={({ field: { onChange, value } }) => (

              <div>
                <Autocomplete
                  className="mt-8 mb-16"
                  freeSolo
                  options={formulacaoPadrao.map((option) => option.no_formulacao_padrao)}
                  value={value}
                  disabled={fieldFormulacaoPadrao}
                  onInputChange={(e, newValue) => {
                    const newValueWithoutRecitar = onChangeFormulacaoPadrao(newValue);
                    onChange(newValueWithoutRecitar);
                    setNivelCognitivoDisabled(false);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Escreva ou selecione a formulação padrão"
                      label="Formulação Padrão"
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                />
              </div>
            )}
          />

          <Controller
            name="nivelCognitivo"
            control={control}
            defaultValue={[]}
            render={({ field: { onChange, value } }) => (
              <Autocomplete
                className="mt-8 mb-16"
                freeSolo
                options={nivelCognitivo.map((option) => option.no_nivel)}
                value={value}
                id='nivelCognitivo'
                disabled={nivelCognitivoDisabled}
                onChange={(event, newValue) => {
                  onChange(newValue);
                  setVerboDisabled(false);
                  const selectedId = valueToIdMapVerbos.get(newValue);
                  findVerbos(selectedId);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Escolha o nível cognitivo"
                    label="Nível Cognitivo"
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                )}
              />
            )}
          />

          <Controller
            name="verbo"
            control={control}
            defaultValue={[]}
            render={({ field: { onChange, value } }) => (
              <Autocomplete
                className="mt-8 mb-16"
                freeSolo
                options={verbos.map((option) => option.no_verbo)}
                value={value}
                id='verbo'
                disabled={verboDisabled}
                onChange={(event, newValue) => {
                  onChange(newValue);
                  setConteudoDisabled(false);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Escolha o verbo do nível cognitivo"
                    label="Verbo"
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                )}
              />
            )}
          />

          <Controller
            name="conteudo"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextField
                onKeyDown={(e) =>
                  handleKeyPress(e, field)
                }
                {...field}
                className="mt-8 mb-16"
                id="conteudo"
                label="Desenvolvimento do conteúdo"
                type="text"
                multiline
                rows={5}
                variant="outlined"
                fullWidth
                disabled={conteudoDisabled}
              />
            )}
          />

          <Box
            className="flex mt-40 py-14 border-t"
          >
            <Button
              className="ml-8"
              variant="contained"
              color="secondary"
              aria-label='Salvar'
              disabled={_.isEmpty(dirtyFields) || !isValid}
              type='submit'
            >
              Salvar
            </Button>
          </Box>
        </form>
      </div>

    </>

  );
}

export default Content;
